export interface RelodeSettings {
    user?: {
        isMenuOpen?: boolean;
    };
}

const settingsKey = "relode:settings";

export const updateRelodeSettings = (newSettings: RelodeSettings) => {
    const currentSettings = getSettingsFromStorage();

    setSettings({ ...currentSettings, ...newSettings });
};

export const setSettings = (settings: RelodeSettings) => {
    if (!settings) return;
    localStorage.setItem(settingsKey, JSON.stringify(settings));
};
export const getSettingsFromStorage = () => {
    const item = localStorage.getItem(settingsKey);
    if (item) return JSON.parse(item);

    // create and return default settings;
    const settings = {
        user: {
            isMenuOpen: true,
        },
    };
    setSettings(settings);
    return settings;
};
